function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Pages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "RF-3.1.7-Lista-de-Entrevistas---Decode",
  transform: "translate(-343.000000, -394.000000)",
  fill: "#F5A623",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Row",
  transform: "translate(255.000000, 372.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_alert_exclamation",
  transform: "translate(88.000000, 22.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10,0 C4.47253906,0 0,4.47292969 0,10 C0,15.5274609 4.47292969,20 10,20 C15.5274609,20 20,15.5270703 20,10 C20,4.47253906 15.5270703,0 10,0 Z M10,18.4375 C5.33621094,18.4375 1.5625,14.6634766 1.5625,10 C1.5625,5.33621094 5.33652344,1.5625 10,1.5625 C14.6637891,1.5625 18.4375,5.33652344 18.4375,10 C18.4375,14.6637891 14.6634766,18.4375 10,18.4375 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10,5.03425781 C9.56851562,5.03425781 9.21875,5.38402344 9.21875,5.81550781 L9.21875,10.8464844 C9.21875,11.2779687 9.56851562,11.6277344 10,11.6277344 C10.4314844,11.6277344 10.78125,11.2779687 10.78125,10.8464844 L10.78125,5.81550781 C10.78125,5.38402344 10.4314844,5.03425781 10,5.03425781 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 10,
  cy: 13.6390625,
  r: 1.0546875
})))));

function SvgIconAlertExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BDA62E4C-D1FE-43C8-A00A-D7D415AA03A6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertExclamation);
export default __webpack_public_path__ + "static/media/icon_alert_exclamation.9e89f6ac.svg";
export { ForwardRef as ReactComponent };